<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <div :class="preCls + 'filter'" style="margin-bottom: 20px">
                <span :class="preCls + 'filter-label'">开始日期</span>
                <DatePicker v-model="startDate"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date">
                </DatePicker>
                <span :class="preCls + 'filter-label'">结束日期</span>
                <DatePicker v-model="endDate"
                    :class="preCls + 'select-public-style'"
                    transfer
                    type="date">
                </DatePicker>
                <check-tag-group style="display: inline-block"
                    v-model="fastDate"
                    color="primary"
                    @on-change="getEndStart">
                    <check-tag v-for="item in fastDateList"
                        :name="item.id"
                        :key="item.id">
                        {{item.text}}
                    </check-tag>
                </check-tag-group>
            </div>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight">
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickInfo(row)">
                        详情
                    </Button>
                    <PoptipButton v-if="$can('delete')"
                        text="删除"
                        transfer
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() => { rowConfirmDelete(row) }">
                    </PoptipButton>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.page"
                @change="fetch">
            </table-pager>
            <!-- 弹出层 -->
            <smart-modal v-model="modal.showFeedback"
                :title="curId ? '反馈编辑' : '反馈登记'"
                :width="800"
                :height="520"
                :maskClosable="false"
                :buttons.sync="formBtns"
                @close-by-confirm="fetch">
                <form-feedback v-if="modal.showFeedback" :id="curId"></form-feedback>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import FormFeedback from './form-feedback'
import { feedbackList, feedbackDel } from '@/api/feedback'
import Dict from '_u/dict'
import dayjs from 'dayjs'
const PAGE_SIZE = 20

export default {
    name: 'ListFeedback',

    components: {
        FormFeedback
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                page: 1,
                pageSize: PAGE_SIZE,
                startDate: this.$cache.startDate,
                endDate: this.$cache.endDate
            },
            page: {
                total: 0,
                list: []
            },
            modal: {
                showFeedback: false
            },
            curId: '',
            fastDateList: [
                { id: 7, text: '近7天' },
                { id: 30, text: '近30天' },
                { id: 90, text: '近90天' }
            ],
            fastDate: [],
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'customerName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'nickname',
                    title: '反馈人',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'feedBackTime',
                    title: '反馈时间',
                    align: 'left',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'replyStatus',
                    title: '状态',
                    align: 'center',
                    width: 100               
                },
                {
                    key: 'replier',
                    title: '回复人',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'replyTime',
                    title: '回复时间',
                    align: 'left',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed:"right",
                    slot: 'action'
                }
            ]
        },

        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : ''
            },
            set(val) {
                this.filter.startDate = dayjs(val).format('YYYY-MM-DD')
            }
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(val) {
                this.filter.endDate = dayjs(val).format('YYYY-MM-DD')
            }
        }
    },

    watch: {
        'filter.startDate': function(val) {
            this.$cache.startDate = val
        },
        'filter.endDate': function(val) {
            this.$cache.endDate = val
        }
    },

    created() {
        this.fetch();
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([feedbackList(this.filter)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showFeedback = true
        },

        rowConfirmDelete(row) {
            this.loading = true
            feedbackDel(row.id)
                .then(() => {this.$Message.success(this.$t('tips.delete.success'))})
                .finally(() => this.fetch())
        },

        clearFast() {
            this.fastDate = []
        },

        getEndStart(el) {
            if (el && el.length) {
                this.filter.startDate = dayjs()
                    .subtract(el[0], 'day')
                    .format('YYYY-MM-DD')
                this.filter.endDate = dayjs().format('YYYY-MM-DD')
                this.fetch()
            }
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>